import { c as _c } from "react/compiler-runtime";
import { patchOrgPlaybooksById } from '@onefootprint/fetch-dashboard';
import type { PatchOrgPlaybooksByIdData } from '@onefootprint/request-types/dashboard';
import { useMutation, useQueryClient } from '@tanstack/react-query';
const useUpdatePlaybook = () => {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      mutationFn: _temp,
      onSuccess: () => {
        queryClient.invalidateQueries();
      }
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
export default useUpdatePlaybook;
function _temp(payload) {
  return patchOrgPlaybooksById(payload);
}